import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import useMediaQuery from "../../../../../hooks/useMediaQuery";
import {setSelectedPrimerPos} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import moment from "moment";
import {toast} from "react-toastify";
import BetterCheckBox from "../../../../common/BetterCheckBox";

const PrimerPosVoucherMultipleSerialsModal = ({multiplePos, setMultiplePos, createVoucher}) => {
    const dispatch = useDispatch();
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const [confirmNotChecked, setConfirmNotChecked] = useState(false);
    const isMobileScreen = useMediaQuery("(max-width: 768px)");

    const statusOptions = [
        {value: "notAvailable", label: "Μη Διαθέσιμο"},
        {value: "waitingStock", label: "Αναμένεται Συσκευή"},
        {value: "available", label: "Διαθέσιμο"},
        {value: "purchased", label: "Δεσμευμένο"},
        {value: "ready", label: "Προς αποστολή"},
        {value: "shipped", label: "Απεσταλμένο"},
        {value: "arrived", label: "Παρελήφθη"}
    ];

    const contractStatusOptions = [
        {value: "noIssue", label: "Δεν έχει εκδοθεί"},
        {value: "issue", label: "Αναμένεται υπογραφή"},
        {value: "signed", label: "Υπεγράφη"},
    ];

    return (
        <Modal backdrop={"static"} className="themeModalMedium" show={multiplePos?.length > 0} onHide={() => setMultiplePos([])}>
            <Modal.Header closeButton>
                <Modal.Title>Πολλαπλές Συσκευές προς Αποστολή</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <span style={{fontSize: "13px"}} className={"text-muted"}><i>
                        Έγινε έλεγχος και βρέθηκαν συσκευές προς αποστολή με τα ίδια στοιχεία πελάτη και στοιχεία αποστολής. Παρακάτω φαίνονται οι αντίστοιχες συσκεύες.
                        Παρακαλώ πολύ ελέγξτε και ολοκληρώστε τα βήματα του συμβολαίου και παραμετροποίησης και στις υπόλοιπες συσκευές και επίλεξτε τις συσκεύες για τις οποίες θέλετε να εκδώσετε ένα voucher.
                        Κατά την έκδοση του Voucher παρακαλώ πολύ ολοκληρώστε και την συσκευασία τους σε ένα κουτί.
                    </i></span>
                    <br />
                    <br />
                    <h5 style={{color: 'red'}}>ΠΡΟΣΟΧΗ! Πάντα προτείνεται οι συσκεύες με ίδια στοιχεία να αποστέλλονται με ένα Voucher σε μεγαλύτερα κουτιά.
                        Εάν για οποιοδήποτε κόλλημα η συσκευές πρέπει να φύγουν με διαφορετική αποστολή - Voucher παρακαλώ ενημερώστε το τμήμα πωλήσεων.</h5>

                <div style={{maxHeight: isMobileScreen ? "60vh" : "70vh", overflowY: 'auto', width: "100%", overflowX: isMobileScreen? 'auto' : 'hidden', padding: "2px"}}>
                    <Row style={{overflowX: "auto"}} className={"mt-2"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable clientMovementsReportTable mb-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                <colgroup>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "4%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th style={{border: "1px solid gray", zoom: "1.2"}}>
                                        <input
                                            type="checkbox"
                                            style={{accentColor: "#f1fdff", cursor: "pointer"}}
                                            checked={!multiplePos?.some((el) => !el?.selectedMultiple)}
                                            name={"selected"}
                                            readOnly={true}
                                            onClick={() => {
                                                setMultiplePos(multiplePos.map((row) => {
                                                    if(row?.contractStatus === "signed" && row?.configurationSteps?.every((el) => el?.status === "completed")) {
                                                        return {...row, selectedMultiple: true};
                                                    } else {
                                                        return row;
                                                    }
                                                }))
                                                if(multiplePos?.some((el) => el?.contractStatus !== "signed" || el?.configurationSteps?.some((el2) => el2?.status !== "completed"))) {
                                                    toast.error("ΠΡΟΣΟΧΉ! Μερικές συσκευές δεν μπόρεσαν να επιλεγούν!");
                                                }
                                            }}
                                        /></th>
                                    <th style={{border: "1px solid gray"}}>A/A</th>
                                    <th style={{border: "1px solid gray"}}>Σειριακός Αριθμός</th>
                                    <th style={{border: "1px solid gray"}}>Θέση Αποθήκης</th>
                                    <th style={{border: "1px solid gray"}}>Συσκευή</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση Συμβολαίου</th>
                                    <th style={{border: "1px solid gray"}}>Κατάσταση Παραμετροποίησης</th>
                                    <th style={{border: "1px solid gray"}}>Ημερομηνία Αγοράς</th>
                                    <th style={{border: "1px solid gray"}}>Ενέργειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {multiplePos?.map((row, idx) => (
                                    <tr
                                        key={`multiplePosTable-${idx}`}
                                        style={{cursor: "pointer", height: "45px", backgroundColor: row?.selectedMultiple ? "#b1fcb1" : ""}}
                                        onClick={() => {
                                            if(row?._id !== selectedPos?._id) {
                                                if(row?.contractStatus !== "signed" || row?.configurationSteps?.some((el) => el?.status !== "completed")) {
                                                    return toast.error("Παρακαλώ ολοκληρώστε πρώτα την διαδικασία συμβολαίου και παραμετροποίησης για να επιλέξετε την συγκεκριμένη συσκευή.")
                                                }
                                                setMultiplePos(multiplePos.map((el) => {
                                                    if(el?._id === row?._id) {
                                                        return {...el, selectedMultiple: !el?.selectedMultiple};
                                                    } else {
                                                        return el;
                                                    }
                                                }))
                                            }
                                        }}
                                    >
                                        <td style={{zoom: "1.2"}}><input type="checkbox" style={{accentColor: "#1a89c8"}} disabled={row?._id === selectedPos?._id ||row?.contractStatus !== "signed" || row?.configurationSteps?.some((el) => el?.status !== "completed")} checked={row?.selectedMultiple} name={"selected"} readOnly={true} /></td>
                                        <td style={{border: "1px solid gray"}}>{idx + 1}</td>
                                        <td style={{border: "1px solid gray"}}>{row["serialNumber"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["warehousePosition"]}</td>
                                        <td style={{border: "1px solid gray"}}>{row["productName"]}</td>
                                        <td style={{border: "1px solid gray"}}>{statusOptions.find((el) => el.value === row["status"])?.label}</td>
                                        <td style={{border: "1px solid gray"}}>{contractStatusOptions.find((el) => el.value === row["contractStatus"])?.label}</td>
                                        <td style={{border: "1px solid gray"}}>
                                            {(() => {
                                                if(row["configurationSteps"].length > 0) {
                                                    if(row["configurationSteps"].every((el) => el.status === "completed")) {
                                                        return `Πλήρως Παραμετροποιημένο (${row["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${row["configurationSteps"]?.length})`
                                                    } else if(row["configurationSteps"].some((el) => el.status === "completed")) {
                                                        return `Μερικώς Παραμετροποιημένο (${row["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${row["configurationSteps"]?.length})`
                                                    } else {
                                                        return `Μη Παραμετροποιημένο (${row["configurationSteps"].filter((el) => el.status === "completed")?.length} / ${row["configurationSteps"]?.length})`
                                                    }
                                                } else {
                                                    return "";
                                                }
                                            })()}
                                        </td>
                                        <td style={{border: "1px solid gray"}}>{row["paidDate"] ? moment(row["paidDate"]).format("DD/MM/YYYY HH:mm") : ""}</td>
                                        <td style={{border: "1px solid gray", padding: "5px"}}>
                                            <div className="d-flex justify-content-between">
                                                <Button style={{padding: "5px", marginLeft: "5px"}} variant={"primary"} onClick={(e) => {
                                                    e.stopPropagation();
                                                    dispatch(setSelectedPrimerPos(row));
                                                }}>
                                                    Άνοιγμα Συσκευής
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer style={{padding: "0.5rem"}}>
                <div style={{flex: 1, justifyContent: 'flex-start'}}>
                    <Button variant="outline-primary" onClick={() => setMultiplePos([])}>
                        Κλείσιμο
                    </Button>
                </div>
                <div style={{flex: 1.7, justifyContent: "flex-end", flexDirection: 'row', display: 'flex'}}>
                    {multiplePos?.some((el) => !el?.selectedMultiple) && (
                        <BetterCheckBox
                            name={"confirmNotChecked"}
                            className={"mt-3 align-content-center"}
                            text={"Επιβεβαιώνω ότι δεν έχω επιλέξει όλες τις συσκεύες και έχω ενημέρωσει"}
                            checked={confirmNotChecked}
                            onChange={(e) => setConfirmNotChecked(e.target.checked)}
                        />
                    )}
                    <Button
                        variant="primary"
                        style={{padding: "12px"}}
                        disabled={!confirmNotChecked && multiplePos?.some((el) => !el?.selectedMultiple)}
                        onClick={() => {
                            createVoucher(false, multiplePos.filter((el) => el?.selectedMultiple === true));
                            setMultiplePos([]);
                            setConfirmNotChecked(false);
                        }}>
                        {`Έκδοση Voucher για τις ${multiplePos?.filter((row) => !!row?.selectedMultiple)?.length || 1} επιλεγμένες συσκευές`}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default PrimerPosVoucherMultipleSerialsModal;